import React, { Component } from "react";
import ajax from "../../ajax";
import functions from "../../functions";
import DashCard from "../Common/DashCard";
import music from "../../audio/2.wav";
import { Howl, Howler } from "howler";

var sound = new Howl({
  src: music,
});

export default class TotalProducts extends Component {
  state = {
    shop_id: functions.sessionGuard(),
    total: false,
  };

  async componentDidMount() {
    await this.getTotalProducts();
    this.timerActual = setTimeout(
      (this.func1 = async () => {
        await this.getTotalProducts();
        this.timerActual = setTimeout(this.func1, 2000); // (*)
      }),
      2000
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timerActual);
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.state.total);
    if (!prevState.total.total) {
      return;
    } else {
      if (prevState.total.total < this.state.total.total) {
        sound.play();
      }
    }
  }

  getTotalProducts = async () => {
    const server_response = await ajax.productsInShop(this.state.shop_id);
    if (server_response.status == "OK") {
      this.setState({
        total: server_response.details,
      });
    }
  };

  render() {
    const { total } = this.state;
    const final = total.total ? total.total : "0";
    return (
      <DashCard
        title="Total Products"
        value={final}
        icon={"fas fa-chart-bar"}
      />
    );
  }
}
